export enum TypePersonEnum {
  INDIVIDUAL_PERSON = 'PI',
  JURIDICAL_PERSON = 'PJ'
}

export const TYPE_PERSON = {
  INDIVIDUAL_PERSON: 'PI',
  JURIDICAL_PERSON: 'PJ'
} as const

export const NAME_TYPE_PERSON = {
  PI: 'Persona individual',
  PJ: 'Persona jurídica'
} as const

export type TypePerson = 'PI' | 'PJ'

export const CATALOG_TYPE_PERSON = [
  {
    value: TYPE_PERSON.INDIVIDUAL_PERSON,
    label: NAME_TYPE_PERSON.PI
  },
  {
    value: TYPE_PERSON.JURIDICAL_PERSON,
    label: NAME_TYPE_PERSON.PJ
  }
]

export enum EnumPersonClient {
  INDIVIDUAL_PERSON = 'individual',
  JURIDICAL_PERSON = 'juridical'
}

export type TypePersonClient = 'individual' | 'juridical'

export const TYPE_PERSON_CLIENT = {
  INDIVIDUAL_PERSON: 'individual',
  JURIDICAL_PERSON: 'juridical'
} as const

export const CATALOG_TYPE_PERSON_APPLICANT = [
  {
    value: TYPE_PERSON_CLIENT.INDIVIDUAL_PERSON,
    label: NAME_TYPE_PERSON.PI
  },
  {
    value: TYPE_PERSON_CLIENT.JURIDICAL_PERSON,
    label: NAME_TYPE_PERSON.PJ
  }
]
